import { Checkbox } from "components/shared/form";
import React, { useState } from "react";
import { alert } from "services/alert";

interface SecretModalProps {
    clientId: string;
    clientName: string;
    secret: string;
    back?: () => void;
    close?: () => void;
}

const copyValue = (value: string) => {
    if (!navigator.clipboard?.writeText) {
        alert({ type: "error", title: "Ошибка", message: "Буфер обмена недоступен." });
        return;
    }
    navigator.clipboard.writeText(value).then(
        () => alert({ type: "success", title: "Скопировано", message: "Значение скопировано." }),
        () => alert({ type: "error", title: "Ошибка", message: "Не удалось скопировать значение." }),
    );
};

/** Show a newly issued secret once and require explicit acknowledgement before closing. */
export default function SecretModal({ clientId, clientName, secret, back, close }: SecretModalProps) {
    const [secretSaved, setSecretSaved] = useState(false);
    const handleClose = close || back;

    return (
        <>
            <div className="modal-window__body">
                <div className="alert alert-warning" role="alert">
                    Скопируйте и сохраните Client Secret в защищённом хранилище. После закрытия окна повторно посмотреть
                    секрет будет невозможно.
                </div>
                <dl className="row mb-3">
                    <dt className="col-sm-3">Название</dt>
                    <dd className="col-sm-9 text-break">{clientName}</dd>
                    <dt className="col-sm-3">Client ID</dt>
                    <dd className="col-sm-9 text-break">
                        <code>{clientId}</code>
                    </dd>
                    <dt className="col-sm-3">Client Secret</dt>
                    <dd className="col-sm-9 text-break">
                        <code>{secret}</code>
                    </dd>
                </dl>
                <div className="d-flex flex-wrap mb-3">
                    <button
                        type="button"
                        className="btn btn-sm btn-secondary mr-2 mb-2"
                        onClick={() => copyValue(clientId)}
                    >
                        Скопировать Client ID
                    </button>
                    <button
                        type="button"
                        className="btn btn-sm btn-secondary mr-2 mb-2"
                        onClick={() => copyValue(secret)}
                    >
                        Скопировать Client Secret
                    </button>
                    <button
                        type="button"
                        className="btn btn-sm btn-secondary mb-2"
                        onClick={() => copyValue(`Client ID: ${clientId}\nClient Secret: ${secret}`)}
                    >
                        Скопировать оба значения
                    </button>
                </div>
                <Checkbox
                    label="Я сохранил Client Secret"
                    labelWrapper="col-auto col-form-label col-form-label-sm pl-0"
                    fieldWrapper="col-auto"
                    bWrapper="row mb-2 align-items-center"
                    inputProps={{ name: "secretSaved" }}
                    value={secretSaved}
                    onChange={({ value }: { value: boolean }) => setSecretSaved(value)}
                    fieldBeforeLabel
                />
            </div>
            <div className="modal-window__footer">
                <button type="button" className="btn btn-brand btn-sm" disabled={!secretSaved} onClick={handleClose}>
                    Закрыть
                </button>
            </div>
        </>
    );
}
